
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class IconEdit2 extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#000" }) public color!: string;
}
